import { render, staticRenderFns } from "./LlQuestionListRiskSort.vue?vue&type=template&id=653f0b8a"
import script from "./LlQuestionListRiskSort.vue?vue&type=script&lang=js"
export * from "./LlQuestionListRiskSort.vue?vue&type=script&lang=js"
import style0 from "./LlQuestionListRiskSort.vue?vue&type=style&index=0&id=653f0b8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports